import React from "react";

export default function Ministers() {
  const ministers = [
    {
      name: "मा. श्री. देवेंद्र फडणवीस",
      post: "मुख्यमंत्री",
      img: "/images/deven.jpg",
    },
    {
      name: "मा. श्री. अजित पवार",
      post: "उपमुख्यमंत्री",
      img: "/images/ajit.jpg",
    },
    {
      name: "मा. श्री. एकनाथ शिंदे",
      post: "उपमुख्यमंत्री",
      img: "/images/eknath.jpg",
    },
    {
      name: "मा. श्री. जयकुमार गोरे",
      post: "ग्रामविकास व पंचायतराज मंत्री",
      img: "/images/ab.jpg",
    },
    {
      name: "मा. श्री. योगेश कदम",
      post: "ग्रामविकास व पंचायतराज राज्यमंत्री",
      img: "/images/kadam.jpeg",
    },
    {
      name: "खासदार",
      post: "सांसद",
      img: "/images/mp.jpg",
    },
    {
      name: "आमदार",
      post: "विधायक",
      img: "/images/mla.jpg",
    },
    {
      name: "वस्त्रोद्योग व पालकमंत्री",
      post: "मंत्री",
      img: "/images/textile.jpeg",
    },
  ];

  const pageStyle = {
    padding: "30px",
    textAlign: "center",
  };

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: "25px",
    marginTop: "30px",
  };

  const cardStyle = {
    background: "white",
    borderRadius: "15px",
    padding: "15px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
    textAlign: "center",
    transition: "0.3s",
  };

  const imgStyle = {
    width: "100%",
    height: "260px",
    borderRadius: "12px",
    objectFit: "cover",
    marginBottom: "12px",
  };

  const nameStyle = {
    fontWeight: "700",
    fontSize: "20px",
    color: "#4A148C",
  };

  const postStyle = {
    fontSize: "17px",
    color: "#333",
    marginTop: "5px",
  };

  return (
    <div style={pageStyle}>
      <h1 style={{ color: "#4A148C", fontSize: "32px", fontWeight: "800" }}>
        महाराष्ट्र राज्य मान्यवर
      </h1>

      <div style={gridStyle}>
        {ministers.map((m, index) => (
          <div
            key={index}
            style={{
              ...cardStyle,
              cursor: "pointer",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
          >
            <img src={m.img} alt={m.name} style={imgStyle} />
            <div style={nameStyle}>{m.name}</div>
            <div style={postStyle}>{m.post}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
